import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getPost } from "../api/post.api";
import DecorLine from "../components/DecorLine";
import MovieReel from "../components/MovieReel";
import MovieCard from "../components/MovieCard";
import ReelLoader from "../components/LoadingReel";

const MoviePost = () => {
  const { postId } = useParams();
  const [postData, setPostData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const fetchPostData = async () => {
      try {
        setIsLoading(true);
        const data = await getPost(postId);
        setPostData(data);
      } catch (err) {
        console.error(err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchPostData();
  }, [postId]);

  if (!postData) return null;

  return (
    <div className="movie-post">
      {isLoading && <ReelLoader />}
      <div className={`movie-post-content ${isLoading ? "hide" : "show"}`}>
        {/* ================= HERO / POSTCARD ================= */}
        <section className="movie-post-hero">
          <div className="hero-rotator">
            <div className="postcard">
              <DecorLine />
              <h1 className="postcard-heading">Felice Post</h1>

              <MovieReel
                scenes={[
                  { id: postData.mid, poster: postData.post_scene?.scene_one },
                  { id: postData.mid, poster: postData.post_scene?.scene_two },
                ]}
              />
            </div>
          </div>
          arl
        </section>

        {/* ================= REVIEW ================= */}
        <section className="movie-post-review">
          <div className="review-layout">
            <div className="review-content">
              <h2 className="film-title">{postData?.title}</h2>

              <h3 className="review-meta">
                TYPE: <span>{postData?.type}</span>
              </h3>

              <h3 className="review-meta">
                SPOILER: <span>{postData?.spoiler ? "YES" : "NO"}</span>
              </h3>

              <div className="review-text">
                <div className="poster-float">
                  <MovieCard
                    id={postData?.mid}
                    poster={postData?.movie.poster}
                  />
                </div>
                <div
                  dangerouslySetInnerHTML={{ __html: postData?.description }}
                />
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default MoviePost;
